/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembershipManageSessionCreatedResponse } from '../../models/membership-manage-session-created-response';

export interface CreateMembershipManageSession$Params {
}

export function createMembershipManageSession(http: HttpClient, rootUrl: string, params?: CreateMembershipManageSession$Params, context?: HttpContext): Observable<StrictHttpResponse<MembershipManageSessionCreatedResponse>> {
  const rb = new RequestBuilder(rootUrl, createMembershipManageSession.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembershipManageSessionCreatedResponse>;
    })
  );
}

createMembershipManageSession.PATH = '/api/memberships/manage-session';
